import React from "react";
import { SERVICES } from "@/lib/pnp";

export default function Marquee() {
  const items = [...SERVICES, ...SERVICES];
  return (
    <section
      data-testid="marquee-section"
      className="pp-marquee relative border-y border-[#DFEBE4] bg-white overflow-hidden py-8 md:py-10"
    >
      <div className="pp-marquee-track flex whitespace-nowrap gap-14 will-change-transform">
        {items.map((s, i) => (
          <div key={i} className="flex items-center gap-14 shrink-0">
            <span
              className="font-display italic font-medium text-[#082E19]"
              style={{ fontSize: "clamp(2.5rem, 6vw, 5rem)", letterSpacing: "-0.02em" }}
            >
              {s.title}
            </span>
            <span className="h-3 w-3 rounded-full bg-[#17C964] shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
}
